import { Toaster } from '@/libs/components/src/lib/ui/sonner';
import { use } from 'react';
import { ThemeContext } from '../../../contexts/theme.context';

const Toasts: React.FC = () => {
  const { theme } = use(ThemeContext);

  return (
    <Toaster
      theme={theme}
      position="bottom-left"
      richColors
      closeButton
      visibleToasts={9}
      className="print:hidden"
    />
  );
};

export default Toasts;
